import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  height: 55rem;
  width: 32.8rem;
  user-select: none;

  @media (max-width: 1600px) {
    width: 33rem;
    height: 45rem;
  }

  @media (max-width: 1366px) {
    width: 25rem;
    height: 40rem;
  }

  @media (max-width: 1280px) {
    width: 25rem;
  }

  .img {
    cursor: pointer;
  }

  .in-loading {
    margin-left: 1000px;
    margin-top: 150px;
  }

  @media (max-width: 1600px) {
    .in-loading {
      margin-left: 700px;
      margin-top: 120px;
    }
  }

  @media (max-width: 1366px) {
    .in-loading {
      margin-left: 500px;
      margin-top: 100px;
    }
  }
`;

export const TemplateThumbnail = styled.img`
  width: 80%;
  height: 70%;
  border-radius: 0rem;
  background-color: #fff;
  -webkit-box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  margin-top: 28px;

  @media (max-width: 1600px) {
    width: 67%;
    height: 70%;
  }

  @media (max-width: 1366px) {
    width: 80%;
    height: 70%;
  }

  @media (max-width: 1280px) {
    width: 80%;
    height: 70%;
  }
`;

export const WrapperPopUp = styled.button<{ isActive: boolean }>`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 26px;
  left: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isActive }) => (isActive ? "#663399" : "#ffffff")};
  border-radius: 5px;
  box-shadow: 0px 0px 36px -3px rgba(0, 0, 0, 0.1);

  @media (max-width: 1600px) {
  }

  @media (max-width: 1366px) {
  }
`;

export const LoadingFlexWrap = styled.div`
  display: flex;
  width: 100vw;
  height: 70vh;
  align-items: center;
  justify-content: center;
`;

export const PopUpWrapper = styled.button`
  width: 280px;
  height: 44px;
  position: absolute;
  top: 66px;
  left: -10px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 18px -7px rgba(0, 0, 0, 0.3);
  padding: 0 27px;
  cursor: pointer;

  span {
    font-size: 1.8rem;
    color: #a5a5a5;
    font-family: "Roboto", sans-serif;
    margin-left: 19px;
  }

  @media (max-width: 1600px) {
  }

  @media (max-width: 1366px) {
  }
`;

export const TemplateName = styled.span`
  text-align: center;
  font-size: 1.8rem;
  color: #a5a5a5;
  margin-top: 1.5rem;
  border: none;
  resize: none;
  overflow: hidden;

  @media (max-width: 1600px) {
    font-size: 1.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.4rem;
  }
`;

export const BottomSpace = styled.div`
  height: 3rem;
  width: 100%;
`;
